import { useField } from "formik";
import { FunctionComponent } from "react";

import Checkbox, {
  CheckboxProps,
} from "@src/modules/shared/components/Form/Checkbox/Checkbox";

const CheckboxField: FunctionComponent<CheckboxProps> = ({
  name,
  children,
  ...props
}) => {
  const [field, meta] = useField<boolean>({ name, type: "checkbox" });
  return (
    <Checkbox
      name={name}
      error={meta.touched && meta.error ? meta.error : undefined}
      field={field}
      {...props}
    >
      {children}
    </Checkbox>
  );
};

export default CheckboxField;
